import type { InstrumentBasicInfoType } from '~/database/supabase/instrument_company/types.js';
import type { CleanNotificationWithRelations } from '~/database/supabase/notifications/types.js';
import { translateEpochGMT } from '~/utils/date.ts';

export const getNotificationDate = (notification: CleanNotificationWithRelations) => {
	switch (true) {
		case !!notification.news:
			return new Date(`${notification.news.date}T${notification.news.time}Z`);
		case !!notification.insider_transaction: {
			const publicationDate = Number(notification.insider_transaction.publication_date);
			const utcEpoch = publicationDate * 1000;
			return new Date(translateEpochGMT(utcEpoch) * 1000);
		}
		case !!notification.short_register_holder:
			return new Date(notification.short_register_holder.date_of_position);
		case !!notification.short_register_aggregated:
			return new Date(notification.short_register_aggregated.date_of_position);
		case !!notification.calendar:
			return notification.calendar.created_at ? new Date(notification.calendar.created_at) : null;
		default:
			return null;
	}
};

export const getMostPopularTicker = (instruments?: InstrumentBasicInfoType[]) => {
	if (!instruments || instruments.length === 0) {
		return '';
	}

	if (instruments?.length === 1) {
		return instruments[0]?.ticker ?? '';
	}

	const validInstruments = instruments.filter(
		(instrument) =>
			instrument.type === 'EQUITY' && instrument.first_trade_date !== null && instrument.first_trade_date !== 0,
	);

	if (validInstruments.length === 0) {
		return instruments[0]?.ticker ?? '';
	}

	return validInstruments.sort((a, b) => (a.first_trade_date ?? 0) - (b.first_trade_date ?? 0))[0]?.ticker ?? '';
};
